import { Auth } from "aws-amplify";
import classNames from "classnames";
import ContainerContent from "components/Container/ContainerContent";
import BarLeasingJobType from "components/Dashboard/BarLeasingJobType";
import ChartJobStatus from "components/Dashboard/ChartJobStatus";
import HeaderStatus from "components/Dashboard/HeaderStatus";
import ChartTimeRemain from "components/Dashboard/ChartTimeRemain";
import LoadingPage from "components/Loading/LoadingPage";
import React, { useEffect, useState, useCallback } from "react";
import { months } from "utils/getLocalDateTime";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import Countdown from "react-countdown";
import API from "./api/api.main"

function LeasingDashboard() {
  const today = getCurrentLocalDateTime();

  const min = `${today.year}-${today.month}-01`;
  const max = `${today.year}-${today.month}-${months[today.monthIndex].days}`;

  const DEFAULT_QUERY = {
    Limit: -1,
    min: today.fullDate,
    max: today.fullDate,
    status: "All",
    package: "All",
  };

  const [activeDuringTime, setActiveDuringTime] = useState("1day");
  const [triggerTime, setTriggerTime] = useState(false);
  const [query, setQuery] = useState(DEFAULT_QUERY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [datas, setDatas] = useState();


  const fetchDashboard = useCallback(async () => {
    try {
      setLoading(true);
      const datas = await API.get("MoneyHubAdmin", "/leasing/request/dashboard", {
        queryStringParameters: {
          ...query,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setDatas(datas);
    } catch (error) {
      console.log("fetch dashboard", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [query]);

  const onDuringTime = (duringTimeKey) => async () => {
    const NEW_QUERY = query;

    if (duringTimeKey === "1month") {
      NEW_QUERY.min = min;
      NEW_QUERY.max = max;
    } else if (duringTimeKey === "1day") {
      const nowToday = today.fullDate;
      NEW_QUERY.min = nowToday;
      NEW_QUERY.max = nowToday;
    }
    setQuery(NEW_QUERY);
    setActiveDuringTime(duringTimeKey);
    await fetchDashboard(NEW_QUERY);
  };

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard, query]);

  useEffect(() => {
    setTimeout(async () => {
      await fetchDashboard();
      setTriggerTime(!triggerTime);
    }, 300000);
  }, [fetchDashboard, triggerTime]);

  const duringTimes = [
    {
      key: "1month",
      name: "1 Month",
    },
    {
      key: "1day",
      name: "1 Day",
    },
  ];

  if (loading)
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  if (error) return <p>Error</p>;

  return (
    <ContainerContent>
      <div className="flex mx-10 mb-4 items-center">
        <div>ดึงข้อมูลตามระยะเวลา</div>
        <div className="flex mx-4 space-x-2">
          {duringTimes.map((duringTime) => (
            <button
              onClick={onDuringTime(duringTime.key)}
              key={duringTime.key}
              className={classNames(
                "border rounded border-gray-200 shadow-sm px-2 py-1 text-white transition-all duration-300 focus:outline-none",
                {
                  "bg-blue-600 ": activeDuringTime === duringTime.key,
                  "bg-gray-400 hover:bg-blue-400":
                    activeDuringTime !== duringTime.key,
                }
              )}
            >
              {duringTime.name}
            </button>
          ))}
        </div>
      </div>
      <HeaderStatus count={datas.count} />
      <div className="grid grid-cols-1 md:grid-cols-2">
        <ChartJobStatus count={datas.count} />
        <BarLeasingJobType countPurpose={datas.countPurpose} />
        <ChartTimeRemain
          title="Time Remain"
          countTimeRemain={datas.countTimeRemain}
        />
        <ChartTimeRemain
          title="Request Waiting Time"
          countTimeRemain={datas.countTimeRemain2}
        />
      </div>
      {/* <div className="px-20">
        <BarJobType />
      </div> */}
      <div className="w-full text-center">
        <span className="mr-4"> จะถูกอัพเดทในอีก </span>
        <Countdown date={Date.now() + 1000 * 300} />
      </div>
    </ContainerContent>
  );
}

export default LeasingDashboard;
